import { render, staticRenderFns } from "./JobOpeningCard.vue?vue&type=template&id=0b1ebbc3&scoped=true"
import script from "./JobOpeningCard.vue?vue&type=script&lang=js"
export * from "./JobOpeningCard.vue?vue&type=script&lang=js"
import style0 from "./JobOpeningCard.vue?vue&type=style&index=0&id=0b1ebbc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ebbc3",
  null
  
)

export default component.exports